import React from 'react';
import * as R from 'ramda';
import { number, shape } from 'prop-types';

// Components
import { Box } from '@mui/material';
import FilterIdentifier from './FilterIdentifier.connector';

const FilterIdentifierPanel = ({ filterCount, filters }) => {
  const filtersMap = [
    { label: 'Affiliate', name: 'affiliate', value: filters.affiliate },
    { label: 'Data Company', name: 'dataCompany', value: filters.dataCompany },
    { label: 'Location', name: 'location', value: filters.location },
    { label: 'Originator', name: 'originator', value: filters.originator },
    { label: 'Recipient', name: 'recipient', value: filters.recipient },
    { label: 'Transfer Date', name: 'transferDate', value: filters.transferDate },
  ];

  const renderFilterIdentifiers = R.compose(
    R.map(({ name, label, value }) => (
      <FilterIdentifier key={name} label={label} name={name} value={value} />
    )),
    // Necessary to properly filter out "Any" and "All" due to different verbiage across modules
    R.reject(R.propEq('value', 'All'))
  );

  return (
    !!filterCount && (
      <Box mb={-5.5} ml={3} mr={0} mt={5.5} zIndex={1}>
        {renderFilterIdentifiers(filtersMap)}
      </Box>
    )
  );
};

FilterIdentifierPanel.propTypes = {
  filterCount: number.isRequired,
  filters: shape({}).isRequired,
};

export default FilterIdentifierPanel;
